import { render, staticRenderFns } from "./leftcolumn.vue?vue&type=template&id=fef0ee60&scoped=true&"
import script from "./leftcolumn.vue?vue&type=script&lang=js&"
export * from "./leftcolumn.vue?vue&type=script&lang=js&"
import style0 from "./leftcolumn.vue?vue&type=style&index=0&id=fef0ee60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef0ee60",
  null
  
)

export default component.exports